module.exports = __webpack_public_path__ + "static/cucumber-6665ce1c557be6a8269f6ecc1aacd12f.svg";